(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function apiBase(root) {
    var endpoint = root.getAttribute('data-endpoint') || 'https://a.wahup.com/api/custom-shirts/popup/';
    return endpoint.replace(/\/popup\/?(?:\?.*)?$/, '/');
  }

  function buildUrl(root) {
    var endpoint = root.getAttribute('data-endpoint') || 'https://a.wahup.com/api/custom-shirts/popup/';
    var url = new URL(endpoint, window.location.href);
    url.searchParams.set('shop', root.getAttribute('data-shop') || '');
    url.searchParams.set('path', root.getAttribute('data-path') || window.location.pathname);
    return url.toString();
  }

  function openPopup(root) {
    root.hidden = false;
    document.documentElement.classList.add('wahup-custom-shirt-popup-open');
  }

  function closePopup(root) {
    root.hidden = true;
    document.documentElement.classList.remove('wahup-custom-shirt-popup-open');
    try {
      window.sessionStorage.setItem('wahup_custom_shirt_popup_closed', '1');
    } catch (error) {}
  }

  function fallbackHtml() {
    return [
      '<div class="wahup-custom-shirt-content">',
      '<p class="wahup-custom-shirt-eyebrow">Custom tee builder</p>',
      '<h2 id="wahup-custom-shirt-popup-title">Create your custom shirt</h2>',
      '<p class="wahup-custom-shirt-copy">The custom shirt builder is loading. Please try again in a moment.</p>',
      '</div>'
    ].join('');
  }

  function afterPageSettled(callback) {
    var run = function () {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout: 2500 });
      } else {
        window.setTimeout(callback, 250);
      }
    };

    if (document.readyState === 'complete') {
      run();
    } else {
      window.addEventListener('load', run, { once: true });
    }
  }

  function transformText(value, mode) {
    var text = String(value || '');
    if (mode === 'uppercase') return text.toUpperCase();
    if (mode === 'lowercase') return text.toLowerCase();
    if (mode === 'titlecase') return text.toLowerCase().replace(/\b\w/g, function (char) { return char.toUpperCase(); });
    return text;
  }

  function slotText(slot, form) {
    var input = form.querySelector('[name="slot_' + slot.id + '"]');
    return transformText(input ? input.value : slot.default_text || slot.placeholder || slot.label, slot.text_transform);
  }

  function renderArchedText(text) {
    var letters = String(text || '').split('');
    return letters.map(function (letter, index) {
      var middle = (letters.length - 1) / 2;
      var rotate = (index - middle) * 3.4;
      var lift = Math.abs(index - middle) * 2.2;
      return '<span style="display:inline-block;transform:translateY(' + lift + 'px) rotate(' + rotate + 'deg)">' + letter.replace(/</g, '&lt;') + '</span>';
    }).join('');
  }

  var loadedFonts = {};

  function ensureFont(slot) {
    var font = slot.default_font;
    if (!font || !font.font_url || loadedFonts[font.id]) return font ? (font.css_family || font.name) : '';
    loadedFonts[font.id] = true;
    var style = document.createElement('style');
    style.textContent = '@font-face{font-family:"' + (font.css_family || font.name).replace(/"/g, '') + '";src:url("' + font.font_url + '") format("truetype");font-display:swap;}';
    document.head.appendChild(style);
    return font.css_family || font.name;
  }

  function renderPreview(template, mockup, form, root) {
    var image = root.querySelector('[data-preview-mockup]');
    var layer = root.querySelector('[data-preview-slots]');
    if (!image || !layer || !mockup) return;
    image.src = mockup.image_url || '';
    layer.innerHTML = '';
    (template.text_slots || []).forEach(function (slot) {
      var box = slot.box || {};
      var x = Number(box.x || 50);
      var y = Number(box.y || 50);
      var w = Number(box.width || 60);
      var h = Number(box.height || 12);
      var el = document.createElement('div');
      el.className = 'wahup-custom-shirt-text-slot';
      el.style.left = (x - w / 2) + '%';
      el.style.top = (y - h / 2) + '%';
      el.style.width = w + '%';
      el.style.height = h + '%';
      el.style.zIndex = Number(box.z_index || 10);
      el.style.transform = 'rotate(' + Number(box.rotation || 0) + 'deg)';
      el.style.color = slot.default_color || '#111111';
      el.style.fontSize = Math.max(12, Number(box.font_size || 36)) + 'px';
      var fontFamily = ensureFont(slot);
      if (fontFamily) el.style.fontFamily = '"' + fontFamily.replace(/"/g, '') + '", Georgia, serif';
      el.style.letterSpacing = Number(slot.letter_spacing || 0) + 'px';
      el.style.lineHeight = Number(slot.line_height || 1);
      el.style.opacity = Math.max(0, Math.min(1, Number(slot.opacity || 1)));
      if (slot.stroke_color && Number(slot.stroke_width || 0) > 0) {
        el.style.webkitTextStroke = Number(slot.stroke_width) + 'px ' + slot.stroke_color;
      }
      if (slot.shadow_color) {
        el.style.textShadow = Number(slot.shadow_x || 0) + 'px ' + Number(slot.shadow_y || 0) + 'px 0 ' + slot.shadow_color;
      }
      if (slot.blend_mode) el.style.mixBlendMode = slot.blend_mode;
      var text = slotText(slot, form);
      el.innerHTML = slot.curve_enabled ? renderArchedText(text) : text.replace(/</g, '&lt;');
      if (slot.curve_enabled && Number(slot.curve_amount || 0)) {
        el.style.transform += ' perspective(900px) rotateX(' + Math.max(-28, Math.min(28, Number(slot.curve_amount || 0) / 2)) + 'deg)';
      }
      layer.appendChild(el);
    });
  }

  function initBuilder(root) {
    var data = document.getElementById('wahup-custom-shirt-template-data');
    if (!data) return;
    var templates = [];
    try { templates = JSON.parse(data.textContent || '[]'); } catch (error) { templates = []; }
    var picker = root.querySelector('[data-template-picker]');
    var builder = root.querySelector('[data-template-builder]');
    var title = root.querySelector('[data-builder-title]');
    var subtitle = root.querySelector('[data-builder-subtitle]');
    var colorOptions = root.querySelector('[data-color-options]');
    var textFields = root.querySelector('[data-text-fields]');
    var form = root.querySelector('[data-shirt-form]');
    var status = root.querySelector('[data-shirt-status]');
    var activeTemplate = null;
    var activeMockup = null;

    function selectTemplate(template) {
      activeTemplate = template;
      activeMockup = (template.mockups || []).find(function (mockup) { return mockup.is_default; }) || (template.mockups || [])[0] || null;
      if (title) title.textContent = template.name;
      if (subtitle) subtitle.textContent = (template.product_type || '').replace(/_/g, ' ') + ' · ' + (template.mockups || []).length + ' colors';
      if (colorOptions) {
        colorOptions.innerHTML = (template.mockups || []).map(function (mockup) {
          return '<button class="wahup-custom-shirt-color" type="button" data-mockup-id="' + mockup.id + '">' +
            (mockup.image_url ? '<img src="' + mockup.image_url + '" alt="" loading="lazy" decoding="async">' : '') +
            '<span>' + mockup.color_name + '</span></button>';
        }).join('');
      }
      if (textFields) {
        textFields.innerHTML = (template.text_slots || []).map(function (slot) {
          var value = slot.default_text || slot.placeholder || '';
          return '<label class="wahup-custom-shirt-label" for="slot_' + slot.id + '">' + slot.label + '</label>' +
            '<input id="slot_' + slot.id + '" name="slot_' + slot.id + '" maxlength="' + (slot.max_length || 40) + '" placeholder="' + (slot.placeholder || slot.label) + '" value="' + String(value).replace(/"/g, '&quot;') + '">';
        }).join('');
      }
      if (picker) picker.hidden = true;
      if (builder) builder.hidden = false;
      root.querySelectorAll('[data-mockup-id]').forEach(function (button) {
        button.classList.toggle('is-active', activeMockup && String(activeMockup.id) === button.getAttribute('data-mockup-id'));
      });
      renderPreview(activeTemplate, activeMockup, form, root);
    }

    root.querySelectorAll('[data-template-id]').forEach(function (button) {
      button.addEventListener('click', function () {
        var id = button.getAttribute('data-template-id');
        var template = templates.find(function (item) { return String(item.id) === String(id); });
        if (template) selectTemplate(template);
      });
    });

    root.querySelector('[data-template-back]')?.addEventListener('click', function () {
      if (builder) builder.hidden = true;
      if (picker) picker.hidden = false;
    });

    colorOptions?.addEventListener('click', function (event) {
      var button = event.target.closest('[data-mockup-id]');
      if (!button || !activeTemplate) return;
      activeMockup = (activeTemplate.mockups || []).find(function (mockup) { return String(mockup.id) === button.getAttribute('data-mockup-id'); }) || activeMockup;
      colorOptions.querySelectorAll('[data-mockup-id]').forEach(function (item) { item.classList.remove('is-active'); });
      button.classList.add('is-active');
      renderPreview(activeTemplate, activeMockup, form, root);
    });

    form?.addEventListener('input', function () {
      if (activeTemplate && activeMockup) renderPreview(activeTemplate, activeMockup, form, root);
    });

    form?.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!activeTemplate || !activeMockup) return;
      if (status) status.textContent = 'Saving preview...';
      var texts = (activeTemplate.text_slots || []).map(function (slot) {
        return { slot_id: slot.id, label: slot.label, text: slotText(slot, form) };
      });
      fetch(apiBase(root) + 'preview/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        mode: 'cors',
        body: JSON.stringify({ template_id: activeTemplate.id, mockup_id: activeMockup.id, texts: texts })
      })
        .then(function (response) { return response.json(); })
        .then(function (payload) {
          if (!payload.ok) throw new Error(payload.error || 'Preview failed');
          if (status) status.textContent = 'Saved. Draft #' + payload.draft_id + ' is ready.';
        })
        .catch(function (error) {
          if (status) status.textContent = error.message || 'Could not save preview.';
        });
    });
  }

  function preparePopupHtml(root, body, html) {
    body.innerHTML = html || fallbackHtml();
    body.querySelectorAll('img').forEach(function (image) {
      image.loading = 'lazy';
      image.decoding = 'async';
    });
    initBuilder(root);
  }

  ready(function () {
    var root = document.getElementById('wahup-custom-shirt-popup-root');
    if (!root) return;

    try {
      if (window.sessionStorage.getItem('wahup_custom_shirt_popup_closed') === '1') return;
    } catch (error) {}

    root.querySelectorAll('[data-custom-shirt-close]').forEach(function (button) {
      button.addEventListener('click', function () { closePopup(root); });
    });

    var delay = parseInt(root.getAttribute('data-delay-ms') || '3000', 10);
    window.setTimeout(function () {
      afterPageSettled(function () {
        var body = root.querySelector('[data-custom-shirt-body]');
        var controller = 'AbortController' in window ? new AbortController() : null;
        var timeout = controller ? window.setTimeout(function () { controller.abort(); }, 3500) : null;
        fetch(buildUrl(root), {
          credentials: 'omit',
          mode: 'cors',
          signal: controller ? controller.signal : undefined
        })
          .then(function (response) {
            if (!response.ok) throw new Error('HTTP ' + response.status);
            return response.json();
          })
          .then(function (payload) {
            if (timeout) window.clearTimeout(timeout);
            preparePopupHtml(root, body, payload && payload.html ? payload.html : fallbackHtml());
            openPopup(root);
          })
          .catch(function () {
            if (timeout) window.clearTimeout(timeout);
            preparePopupHtml(root, body, fallbackHtml());
            openPopup(root);
          });
      });
    }, Number.isFinite(delay) ? delay : 3000);
  });
})();
